import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../contexts/AppContext';
import { translations } from '../data/menuData';
import { HeroLogo } from './HeroLogo';
import { HeroSearchBar } from './HeroSearchBar';
import { HeroCTAButtons } from './HeroCTAButtons';
import { HeroInfoPanel } from './HeroInfoPanel';

const HERO_INITIAL = { opacity: 0, x: -50 };
const HERO_ANIMATE = { opacity: 1, x: 0 };
const HERO_TRANSITION = { duration: 0.6, delay: 0.2 };

export const HeroSection = ({ query, setQuery }) => {
  const { language } = useApp();
  const t = translations[language];

  return (
    <section className="py-8 md:py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-6 lg:grid-cols-[1fr_auto]">
          <motion.div
            className="space-y-6"
            initial={HERO_INITIAL}
            animate={HERO_ANIMATE}
            transition={HERO_TRANSITION}
          >
            <HeroLogo restaurantName={t.restaurantName} tagline={t.tagline} />
            <HeroSearchBar query={query} setQuery={setQuery} placeholder={t.searchPlaceholder} />
            <HeroCTAButtons callText={t.callNow} />
          </motion.div>
          <HeroInfoPanel t={t} />
        </div>
      </div>
    </section>
  );
};
